import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FlagsPage } from './flags.page';

const routes: Routes = [
  {
    path: '',
    component: FlagsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FlagsPageRoutingModule {}
